module.exports = "/images/bertrandHardy.jpg?0f19607c6dd9d3a6d6b795e1df5a45b0";